import React from "react";
import PropTypes from "prop-types";
import { TextField } from "@mui/material";

const CustomTextField = ({
  label,
  value,
  onChange,
  onBlur,
  required,
  maxLength,
  textColor,
  inputColor,
  height,
  width,
  disabled,
  backgroundColor,
  borderRadius,
  ...restProps
}) => {
  const handleInputChange = (e) => {
    if (maxLength) {
      e.target.value = e.target.value.slice(0, maxLength);
    }

    if (onChange) {
      onChange(e);
    }
  };

  const characterCount = maxLength && value ? value.length : null;

  const renderLabel = () => {
    const capitalizedLabel = label
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
    return (
      <>
        {capitalizedLabel}
        {required && <span style={{ color: "red", marginLeft: "4px" }}>*</span>}
      </>
    );
  };

  return (
    <div style={{ position: "relative", width: width || "100%" }}>
      <TextField
        label={renderLabel()}
        fullWidth
        value={value}
        onChange={handleInputChange}
        onBlur={onBlur}
        margin="normal"
        disabled={disabled}
        style={{
          height: height || "auto",
          width: "100%",
          backgroundColor: backgroundColor || "#f9f9f9",
          borderRadius: borderRadius || "8px",
          boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
          transition: "all 0.3s ease-in-out",
        }}
        InputLabelProps={{
          style: { color: textColor || "#757575", fontSize: "0.9rem" },
        }}
        InputProps={{
          style: {
            color: inputColor || "#333",
            height: height || "auto",
            borderRadius: borderRadius || "8px",
          },
        }}
        sx={{
          "& .MuiOutlinedInput-root": {
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderColor: "#00a8a2",
            },
          },
        }}
        {...restProps}
      />
      {characterCount !== null && maxLength && (
        <div
          style={{
            position: "absolute",
            right: "10px",
            bottom: "-20px",
            fontSize: "0.75rem",
            color: characterCount === maxLength ? "red" : "#757575",
          }}
        >
          {`${characterCount}/${maxLength}`}
        </div>
      )}
    </div>
  );
};

CustomTextField.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string, // Assuming value is a string, adjust if it's a different type
  onChange: PropTypes.func,
  type: PropTypes.string,
  maxLength: PropTypes.number,
  fullWidth: PropTypes.bool,
  required: PropTypes.bool,
  textColor: PropTypes.string,
  inputColor: PropTypes.string,
  height: PropTypes.number,
  width: PropTypes.string,
  backgroundColor: PropTypes.string,
  borderRadius: PropTypes.string,
  disabled: PropTypes.bool,
};

export default CustomTextField;
